import { useTheme } from '@mui/material/styles';

const spacing = (factor: number) => `${8 * factor}px`;

export const useStyles = () => {
  const theme = useTheme();
  return {
    root: {
      padding: spacing(4),
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
      minHeight: '100vh',
    },
    section: {
      background: 'white',
      borderRadius: '12px',
      padding: spacing(4),
      margin: `${spacing(2)} 0`,
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      border: 'none',
      transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.12)',
      },
    },
    dealerSelect: {
      marginTop: spacing(4),
      marginLeft: spacing(4),
      width: 240,
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    gridContainer: {
      padding: `${spacing(4)} !important`,
    },
    paper: {
      background: 'white',
      borderRadius: '16px !important',
      height: 'auto',
      padding: spacing(6),
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
      border: 'none',
    },
    dealerTypography: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '50vh',
      color: theme.palette.text.secondary,
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    generateTemplateButton: {
      color: 'white !important',
      marginTop: spacing(12) + ' !important',
      background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%) !important',
      borderRadius: '8px !important',
      padding: '12px 24px !important',
      transition: 'transform 0.2s ease-in-out !important',
      '&:hover': {
        transform: 'scale(1.02)',
      },
    },
    downloadButton: {
      marginLeft: 'auto !important',
      paddingRight: spacing(4) + ' !important',
      background: 'linear-gradient(45deg, #4CAF50 30%, #45a049 90%) !important',
      borderRadius: '8px !important',
      transition: 'transform 0.2s ease-in-out !important',
      '&:hover': {
        transform: 'scale(1.02)',
      },
    },
    tableRow: {
      transition: 'background-color 0.2s ease-in-out',
      '&:nth-of-type(odd)': {
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
      },
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
      '&:last-child td, &:last-child th': {
        border: 0,
      },
    },
    modalActionButtonContainer: {
      float: 'right',
      marginRight: spacing(1),
      marginTop: spacing(4),
      marginBottom: spacing(3),
    },
    modalCancelButton: {
      color: 'white !important',
      marginRight: spacing(4) + ' !important',
      background: 'linear-gradient(45deg, #FF5252 30%, #FF1744 90%) !important',
      borderRadius: '8px !important',
      transition: 'transform 0.2s ease-in-out !important',
      '&:hover': {
        transform: 'scale(1.02)',
      },
    },
    buttonSave: {
      color: 'white !important',
      background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%) !important',
      borderRadius: '8px !important',
      transition: 'transform 0.2s ease-in-out !important',
      '&:hover': {
        transform: 'scale(1.02)',
      },
    },
    tabContainer: {
      marginTop: spacing(4),
      borderBottom: 1,
      borderColor: 'divider',
      marginBottom: spacing(2),
    },
    imageContainer: {
      maxHeight: 50,
      cursor: 'pointer',
      zIndex: 999,
      transition: 'transform 0.2s ease-in-out',
      '&:hover': {
        transform: 'scale(1.05)',
      },
    },
    modalHeader: {
      textAlign: 'center',
      marginBottom: spacing(8) + ' !important',
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
    modalInputs: {
      marginBottom: spacing(3) + ' !important',
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    previewImageContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: spacing(2),
      borderRadius: '8px',
      background: 'rgba(0, 0, 0, 0.02)',
    },
    folderName: {
      textAlign: 'end',
      color: theme.palette.text.secondary,
      fontWeight: 500,
    },
    navigationLink: {
      '&:visited': { color: theme.palette.text.primary },
      textDecoration: 'none',
      transition: 'color 0.2s ease-in-out',
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    modalButtonContainer: {
      display: 'flex !important',
      marginTop: spacing(4) + ' !important',
      gap: spacing(2),
    },
    modalButton: {
      textTransform: "none",
      fontSize: "14px",
      color: 'white !important',
      marginRight: spacing(3) + ' !important',
      background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%) !important',
      borderRadius: '8px !important',
      transition: 'transform 0.2s ease-in-out !important',
      '&:hover': {
        transform: 'scale(1.02)',
      },
    },
    modalButtonCancel: {
      textTransform: "none",
      fontSize: "14px",
      marginLeft: 'auto !important',
      color: theme.palette.text.primary + ' !important',
      marginRight: spacing(3) + ' !important',
      background: 'rgba(0, 0, 0, 0.04) !important',
      borderRadius: '8px !important',
      transition: 'all 0.2s ease-in-out !important',
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.08) !important',
        transform: 'scale(1.02)',
      },
    },
    modalButton2: {
      textTransform: "none",
      fontSize: "14px",
      color: "white",
      background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%) !important',
      borderRadius: '8px !important',
      transition: 'transform 0.2s ease-in-out !important',
      '&:hover': {
        transform: 'scale(1.02)',
      },
    },
    errorContainer: {
      padding: spacing(4),
      margin: spacing(3),
      borderRadius: '12px',
      backgroundColor: '#fff5f5',
      color: '#e53e3e',
      boxShadow: '0 4px 20px rgba(229, 62, 62, 0.1)',
      border: '1px solid rgba(229, 62, 62, 0.2)',
    },
    errorTypography: {
      marginBottom: spacing(3),
      fontWeight: 600,
    },
    errorHelpText: {
      '& ul': {
        marginTop: spacing(2),
        paddingLeft: spacing(4),
      },
      '& li': {
        marginBottom: spacing(1),
        color: '#4a5568',
      },
    },
  };
};

export const calendarEventStyle = ({ backgroundColor }: { backgroundColor: string }) => ({
  background: `linear-gradient(135deg, ${backgroundColor} 0%, ${backgroundColor}dd 100%)`,
  color: 'white',
  borderRadius: '12px',
  border: 'none',
  height: '45px',
  width: '45px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
  fontWeight: 'bold',
  margin: '0 auto',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
});

export const inactiveDayStyle = {
  background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
  color: '#9e9e9e',
  border: 'none',
  height: '25px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '15px',
  fontWeight: 'bold',
  borderRadius: '6px',
  opacity: 0.7,
};

export const noEventStyle = {
  background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
  color: '#9e9e9e',
  border: 'none',
  display: 'flex',
  height: '100%',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1px',
  margin: '0 auto',
  borderRadius: '6px',
  opacity: 0.5,
};
